import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    manageQuestion: {},
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_QUESTION_TO_MANAGE:
            return { ...state, manageQuestion: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/manage-question/manage-question.reducer.js